import { SERVICE_DETAILS_2025 } from "@/constants/servicePackageDetails/service2025";
import { customEvent } from "goi_common";
import { useRouter } from "next/router";
import { useMemo } from "react";

const SERVICE_ROUTER_PATH = `/service`;

export const useServicePackage = () => {
  const router = useRouter();
  const servicePackageDetails = SERVICE_DETAILS_2025;

  const currentServiceType = useMemo(() => {
    if (!router.isReady) return null;
    else {
      if (router.query.type as string) {
        if (router.pathname.includes("premium")) {
          return router.query.type === "가족장" ? "가족장 프리미엄" : "일반장 프리미엄";
        }

        return router.query.type as string;
      } else {
        return "가족장";
      }
    }
  }, [router]);

  const handleServiceTabChange = (selectedServiceType: string) => {
    router.replace(`${SERVICE_ROUTER_PATH}/${selectedServiceType}`);
    customEvent({
      newGtm: {
        path: "service",
        trigger_and_target: "tab_type-view_type",
        text: selectedServiceType,
      },
    });
  };

  const serviceDetails = useMemo(() => {
    return servicePackageDetails?.[currentServiceType as keyof typeof servicePackageDetails];
  }, [currentServiceType, servicePackageDetails]);

  return {
    currentServiceType,
    servicePackageDetails,
    handleServiceTabChange,
    serviceDetails,
  };
};
